import React, { Component } from "react";

export default class InterestCell extends Component {
  deleteInterest = () => {
    this.props.onDelete(this.props.interest);
  };

  editInterest = () => {
    this.props.onEdit({ ...this.props.interest, updateFromInside: true });
  };

  render() {
    var { interest } = this.props.interest;

    return (
      <tr>
        <td>{interest}</td>
        <td>
          <div className="action-button-area pull-right">
            {/* <div className="action-button vcenter ml-10"><button className="btn btn-custom-table-white" onClick={this.editInterest}>EDIT</button></div> */}
            {this.props.canbeDeleted ? (
              <div className="action-button ml-94">
                <button
                  className="i-custom-table-delete"
                  onClick={this.deleteInterest}
                >
                  <img
                    className="i-custom-table"
                    src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                  />
                </button>
              </div>
            ) : (
              <div className="action-button ml-10"></div>
            )}
          </div>
        </td>
      </tr>
    );
  }
}
